module.exports = __webpack_public_path__ + "assets/images/BBD50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BBD50.png
// module id = 1313
// module chunks = 1